import {jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs} from "react/jsx-runtime";import {Comment, LinearScale, Update} from '@mui/icons-material'
import * as ScrollArea from '@radix-ui/react-scroll-area'
import graphql from 'babel-plugin-relay/macro'
import {useFragment} from 'react-relay'




import {cn} from '../../ui/cn'





export const RetroDescription = (props) => {
  const {prompts} = props
  return (
    _jsx(_Fragment, { children: 
      prompts.map((prompt) => (
        _jsxs('div', { className: "mb-1 flex flex-col items-start py-1 sm:flex-row"     , children: [
          _jsx('div', {
            className: "mt-1 mr-4 h-3 w-3 shrink-0 self-start rounded-full"      ,
            style: {backgroundColor: prompt.groupColor},}
          )
          , _jsxs('div', { className: "flex min-w-0 grow flex-col"   , children: [
            _jsx('div', { className: "font-semibold text-sm" , children: prompt.question})
            , _jsx('div', { className: "font-normal text-sm" , children: prompt.description})
          ]})
        ]}, prompt.id)
      ))
    })
  )
}





const PokerDescription = (props) => {
  const {dimensions} = props
  return (
    _jsx(_Fragment, { children: 
      dimensions.map((dimension) => (
        _jsxs('div', { className: "mb-1 flex items-center py-1 sm:flex-row"    , children: [
          _jsx('div', { className: "mr-4 shrink-0 self-start"  , children: 
            _jsx(LinearScale, { className: "h-4 w-4" ,} )
          })
          , _jsxs('div', { className: "flex min-w-0 grow flex-col"   , children: [
            _jsx('div', { className: "font-semibold text-sm" , children: dimension.name})
            , _jsx('div', { className: "font-normal text-sm" , children: dimension.selectedScale.name})
          ]})
        ]}, dimension.id)
      ))
    })
  )
}

const ActionDescription = () => {
  const items = [
    {
      icon: _jsx(Update, { className: "h-5 w-5" ,} ),
      description: 'Solo Updates'
    },
    {
      icon: _jsx(Comment, { className: "h-5 w-5" ,} ),
      description: 'Team Agenda'
    }
  ]

  return (
    _jsx(_Fragment, { children: 
      items.map((item, index) => (
        _jsxs('div', { className: "mb-1 flex items-start py-1 sm:flex-row"    , children: [
          _jsx('div', { className: "mr-4 flex shrink-0 items-center self-start"    , children: item.icon})
          , _jsx('div', { className: "flex min-w-0 grow flex-col"   , children: 
            _jsx('div', { className: "font-normal text-sm" , children: item.description})
          })
        ]}, index)
      ))
    })
  )
}

const TeamPromptDescription = () => {
  const items = [
    {
      icon: _jsx(Comment, { className: "h-5 w-5" ,} ),
      description: 'What are you working on today? Stuck on anything?'
    }
  ]

  return (
    _jsx(_Fragment, { children: 
      items.map((item, index) => (
        _jsxs('div', { className: "mb-1 flex items-start py-1 sm:flex-row"    , children: [
          _jsx('div', { className: "mr-4 flex shrink-0 items-center self-start"    , children: item.icon})
          , _jsx('div', { className: "flex min-w-0 grow flex-col"   , children: 
            _jsx('div', { className: "font-normal text-sm" , children: item.description})
          })
        ]}, index)
      ))
    })
  )
}






export const ActivityLibraryCardDescription = (props) => {
  const {className, templateRef} = props

  const template = useFragment(
    graphql`
      fragment ActivityLibraryCardDescription_template on MeetingTemplate {
        type
        ... on PokerTemplate {
          dimensions {
            id
            name
            description
            selectedScale {
              name
            }
          }
        }
        ... on ReflectTemplate {
          prompts {
            id
            question
            groupColor
            description
          }
        }
      }
    `,
    templateRef
  )

  return (
    _jsxs(ScrollArea.Root, { className: cn('flex-1 overflow-auto', className), children: [
      _jsx(ScrollArea.Viewport, { children: 
        _jsxs('div', { className: "flex flex-1 flex-col gap-y-1 px-2 py-1 text-slate-900"      , children: [
          template.type === 'retrospective' && _jsx(RetroDescription, { prompts: template.prompts,} )
          , template.type === 'poker' && _jsx(PokerDescription, { dimensions: template.dimensions,} )
          , template.type === 'action' && _jsx(ActionDescription, {} )
          , template.type === 'teamPrompt' && _jsx(TeamPromptDescription, {} )
        ]})
      })
      , _jsx(ScrollArea.Scrollbar, { orientation: "vertical", className: "hidden",} )
    ]})
  )
}
